// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sC7xQM {
  border-radius: var(--radius-xs);
  background-color: var(--surface-neutral-pale, #fafafa);
  padding: var(--spacing-2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.NMHjk8 {
  border: 1px solid var(--text-neutral-medium, #666666);
  cursor: default;
}

.NIpqaa {
  gap: var(--spacing-1-5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.xANctG {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-lg, 16px);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark, #1a1a1a);
}

.ps61kz {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
}

.mt7rRd {
  height: var(--font-size-lg, 16px);
  width: var(--font-size-lg, 16px);
  border-radius: 100%;
  background-color: var(--surface-background, #fafafa);
  border: 1px solid var(--text-neutral-dark);
  cursor: pointer;
}

.ZTSNRN {
  border: none;
  background-color: var(--surface-primary-medium, #d64000);
  position: relative;
}

.ZTSNRN::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: var(--surface-background, #ffffff);
}

.UDHcq1 {
  overflow: hidden;
  transition:
    max-height 0.2s ease-in-out,
    opacity 0.2s ease-in-out;
  max-height: 0;
  opacity: 0;
}

.ReyyrX {
  max-height: 1000px; /* Adjust based on your expected content height */
  opacity: 1;
  padding-top: var(--spacing-1, 8px);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ToggleAccordionItem/ToggleAccordionItem.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,sDAAsD;EACtD,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iEAAiE;EACjE,oCAAoC;EACpC,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,mBAAmB;EACnB,oDAAoD;EACpD,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB;;4BAE0B;EAC1B,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB,EAAE,iDAAiD;EACrE,UAAU;EACV,kCAAkC;AACpC","sourcesContent":[".item {\n  border-radius: var(--radius-xs);\n  background-color: var(--surface-neutral-pale, #fafafa);\n  padding: var(--spacing-2);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.selectedItem {\n  border: 1px solid var(--text-neutral-medium, #666666);\n  cursor: default;\n}\n\n.inner {\n  gap: var(--spacing-1-5);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-lg, 16px);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark, #1a1a1a);\n}\n\n.markSlot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.mark {\n  height: var(--font-size-lg, 16px);\n  width: var(--font-size-lg, 16px);\n  border-radius: 100%;\n  background-color: var(--surface-background, #fafafa);\n  border: 1px solid var(--text-neutral-dark);\n  cursor: pointer;\n}\n\n.selectedMark {\n  border: none;\n  background-color: var(--surface-primary-medium, #d64000);\n  position: relative;\n}\n\n.selectedMark::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 6px;\n  height: 6px;\n  border-radius: 100%;\n  background-color: var(--surface-background, #ffffff);\n}\n\n.content {\n  overflow: hidden;\n  transition:\n    max-height 0.2s ease-in-out,\n    opacity 0.2s ease-in-out;\n  max-height: 0;\n  opacity: 0;\n}\n\n.contentExpanded {\n  max-height: 1000px; /* Adjust based on your expected content height */\n  opacity: 1;\n  padding-top: var(--spacing-1, 8px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `sC7xQM`,
	"selectedItem": `NMHjk8`,
	"inner": `NIpqaa`,
	"title": `xANctG`,
	"markSlot": `ps61kz`,
	"mark": `mt7rRd`,
	"selectedMark": `ZTSNRN`,
	"content": `UDHcq1`,
	"contentExpanded": `ReyyrX`
};
module.exports = ___CSS_LOADER_EXPORT___;
